// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22L2 22V2ZM6.5 11V13L17.5 13V11L6.5 11Z"}}]};

const MinusRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'minus-rectangle-filled',
    ref,
    icon: element,
  },
));

MinusRectangleFilledIcon.displayName = 'MinusRectangleFilledIcon';

export default MinusRectangleFilledIcon;
